import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=64db5588"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=64db5588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports